export const FirebaseConfiguration = {
    apiKey: process.env.REACT_APP_FirebaseApiKey,
    authDomain: process.env.REACT_APP_FirebaseAuthDomain,
    databaseURL: process.env.REACT_APP_FirebaseDatabaseURL,
    projectId: process.env.REACT_APP_FirebaseProjectId,
    storageBucket: process.env.REACT_APP_FirebaseStorageBucket,
    messagingSenderId: process.env.REACT_APP_FirebaseMessagingSenderId,
};
